import React, { useMemo } from 'react';
import './style.scss';
import clsx from 'clsx';
import SVGLogo from '../../../assets/images/logo';

interface LoaderProps {
  size?: number | string;
  color?: 'white' | 'primary' | 'invalid';
  className?: string;
  style?: any;
  useAbsoluteWrapper?: boolean;
  slowAppear?: boolean;
}

const Loader = ({
  size = 120,
  color: colorCode = 'white',
  className = '',
  style,
  useAbsoluteWrapper = false,
  slowAppear
}: LoaderProps) => {
  const wrapperClassName = useMemo<string>(() => {
    return clsx(
      'loader-wrapper',
      useAbsoluteWrapper && 'loader-wrapper-absolute',
      slowAppear && 'loader-wrapper-slow-appear',
      className
    );
  }, [useAbsoluteWrapper, className]);

  const wrapperStyle = useMemo(() => {
    return {
      minWidth: size,
      minHeight: size,
      ...style
    };
  }, [style, size]);

  const innerStyle = useMemo(() => {
    return {
      width: size,
      height: size
    };
  }, [size]);

  const color = useMemo<string>(() => {
    if (colorCode === 'white') return '#FFF';
    if (colorCode === 'invalid') return '#FFD029';
    return '#FF009C';
  }, [colorCode]);

  return (
    <div className={wrapperClassName} style={wrapperStyle}>
      <div className='loader' style={innerStyle}>
        <SVGLogo color={color} />
      </div>
    </div>
  );
};

export default Loader;
